import React, { useState } from "react";
import Section from "../../components/layout/Section";
import {
  Box,
  Button,
  Typography,
  Link,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import FontPreview from "../../components/layout/FontPreview";


const fonts = [
  {
    name: 'nc trading - pencil and heart',
    penRequired: false,
    neohtml: '[center][fontc=0]neoHTML[/font][p][fontc=#268] . · * ◝   [/font][fontc=#a34]❤[/font][br][fontc=#706f=cafeteria][',
    neosignature: '] (dti link)[/font][br][fontc=#e80]✐[/font][fontc=#916]    * . ·˙   [/font][/center]',
    previewImg: require('../../assets/fonts/ncpencil.png'),
    avatarURL: 'https://images.neopets.com/neoboards/avatars/deadlydice.gif',
    avatarLabel: 'count von roo avatar',
  },
  {
    name: 'nc heart',
    penRequired: false,
    neohtml: '[center][fontc=0]neoHTML[/font][p][fontc=#E7Df=georgia].[sup] · * ˙ * · .    . · * ˙ * · [/sup].[br][i][sup]✧[/sup]·. [',
    neosignature: '] nc tl/wl  .·[sup]✧[/sup][br](dti link)[br]* · . · *[/i][/font][/center]',
    previewImg: require('../../assets/fonts/ncheart.png'),
    avatarURL: 'https://images.neopets.com/neoboards/avatars/kadoatery.gif',
    avatarLabel: 'kadoatery avatar',
  },
  {
    name: 'nc simple name',
    penRequired: false,
    neohtml: '[center][fontc=0]neoHTML[/font][p][fontc=#da2f=cafeterias=3]─── name here ───[/font][br][fontc=#471f=monospace][',
    neosignature: '] (dti link)[/font][br][fontc=#b63]─── ✯ ❤ ✯ ───[/font][/center]',
    previewImg: require('../../assets/fonts/ncsimplename.png'),
    avatarURL: 'https://images.neopets.com/neoboards/avatars/techobuzz.gif',
    avatarLabel: 'buzzer game avatar',
  },
  {
    name: 'name crown 2',
    penRequired: true,
    neohtml: '[center][fontc=greyf=tahoma]neoHTML[/font][p][fontc=#fb2][sub].[/sub]. · ♕ .      [br] ✧[/font][fontc=#69cf=georgia]  [b]Name[/b]     [/font][',
    neosignature: '][fontc=#9be]✵[/font][br][fontc=#969s=1](dti link)[/font][br][fontc=#f90]     ˙· . . ✶ ˙[/font][/center]',
    previewImg: require('../../assets/fonts/nccrown2.png'),
    avatarURL: 'https://images.neopets.com/neoboards/avatars/plushieeyrie.gif',
    avatarLabel: 'plushie eyrie avatar',
  },
  {
    name: 'name crown 1',
    penRequired: false,
    neohtml: '[center][fontc=grey]neoHTML[/font][p][fontc=#fb2][sub].[/sub]. · ♕ .     [br] ✧[/font][fontc=#69cf=georgia]  [b]Name[',
    neosignature: '][/b]     [/font][br][fontc=#969s=1](dti link)[br]      ˙· . . ✶ ˙[/font][/center]',
    previewImg: require('../../assets/fonts/nccrown1.png'),
    avatarURL: 'https://images.neopets.com/neoboards/avatars/plushieeyrie.gif',
    avatarLabel: 'plushie eyrie avatar',
  },
  {
    name: 'nc trading 3',
    penRequired: true,
    neohtml: '[center][fontc=greyf=verdanas=1]neoHTML[/font][p][fontc=#68ef=rockwell].✧ ˙[b] name    [/b][br][/font][fonts=1f=calibric=#98e][',
    neosignature: '](dti link)[br][/font][fontc=#83cf=georgia]˙· . . · ˙ ˙ [sup]▸ nc uft ミ[/sup][/font][fontc=#c7e]★[/font][/center]',
    previewImg: require('../../assets/fonts/nctrading3.png'),
    avatarURL: 'https://images.neopets.com/neoboards/avatars/ava_udtcgshoyru.gif',
    avatarLabel: 'arcade shoyru avatar',
  },
  {
    name: 'nc trading 2',
    penRequired: true,
    neohtml: '[center][fontc=0]neoHTML[/font][p][fontc=#99e]✧ . . · * ˙ ✯ ｎｃ ｕｆｔ ✧ ˙ * · . . ✱[br][/font][fonts=1c=#c9e](dti link)[',
    neosignature: '][br](next dti link)[br][/font][fontc=#76cf=georgia]              · * ˙ * · . [sub]➸[/sub] [b]name[/b][/font][/center]',
    previewImg: require('../../assets/fonts/nctrading2.png'),
    avatarURL: 'https://images.neopets.com/neoboards/avatars/faeriepeo.gif',
    avatarLabel: 'faerie peophin avatar',
  },
  {
    name: 'nc trading 1',
    penRequired: false,
    neohtml: '[center][fontc=greyf=verdanas=1]neoHTML[/font][p][fontc=#68ef=rockwell].✧ ˙[b] name    [/b][br][/font][fonts=1f=calibric=#98e][',
    neosignature: '](dti link)[br][/font][fontc=#76cf=georgia][b]              ➣ name[/b][/font][/center]',
    previewImg: require('../../assets/fonts/nctrading1.png'),
    avatarURL: 'https://images.neopets.com/neoboards/avatars/faeriepeo.gif',
    avatarLabel: 'faerie peophin avatar',
  }
]

const NeosignaturesPage = () => {

  const [userLink, setUserLink] = useState('')
  const [tradelistId, setTradelistId] = useState('')

  const [DTILink, setDTILink] = useState('')
  const [DTI2020Link, setDTI2020Link] = useState('')
  const [preference, setPreference] = useState("classic");
  const [linkError, setLinkError] = useState(false);
  const [fontList, setFontList] = useState(fonts);

  const convertFonts = (fonts, dtiLink1) => {
    return fonts.map((obj) => {
      const limit = obj.penRequired ? 150 : 120;
      let { neohtml, neosignature } = obj;

      const original = { ...obj }; // backup if we need to revert

      // Ensure structural brackets exist
      if (!neohtml.endsWith("[")) neohtml += "[";
      if (!neosignature.startsWith("]")) neosignature = "]" + neosignature;

      // Replace placeholder
      if (neohtml.includes("(dti link)")) {
        neohtml = neohtml.replace("(dti link)", dtiLink1);
        if (neohtml.length > limit) {
          const overflow = neohtml.slice(limit);
          neohtml = neohtml.slice(0, limit);

          // Insert overflow just after the leading ]
          neosignature = neosignature[0] + overflow + neosignature.slice(1);
        }
      } else if (neosignature.includes("(dti link)")) {
        neosignature = neosignature.replace("(dti link)", dtiLink1);
        if (neosignature.length > limit) {
          const overflow = neosignature.slice(limit);
          neosignature = neosignature.slice(0, limit);

          // Insert overflow just before the trailing [
          neohtml = neohtml.slice(0, -1) + overflow + "[";
        }
      }

      // Final safety: if either box still exceeds the limit, revert
      if (neohtml.length > limit || neosignature.length > limit) {
        return original;
      }

      return { ...obj, neohtml, neosignature };
    });
  }

  const handleSave = () => {
    if (tradelistId) {
      const preferredLink = preference === 'classic' ? DTILink : DTI2020Link
      setFontList(convertFonts(fonts, preferredLink))
    }
  }


  const validateLink = (input) => {
    const regex = /^(?:https?:\/\/)?(impress.openneo.net|impress-2020.openneo.net)\/user\/(\d{1,7})(?:-[^/]+)?\/(closet|lists)$/;
    const match = input.match(regex);
    if (match) {
      setTradelistId(match[2])
      setDTI2020Link(`impress-2020.openneo.net/user/${match[2]}/lists`)
      setDTILink(`impress.openneo.net/user/${match[2]}/closet`)
      return true
    }
    else {
      return false
    }
  }

  const userDetails = () => {
    return (
      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          maxWidth: 400,
        }}
      >

        {/* Link input */}
        <TextField
          label="DTI Tradelist Link"
          variant="outlined"
          size="small"
          value={userLink}
          onChange={(e) => {
            setUserLink(e.target.value);
            if (validateLink(e.target.value) || e.target.value === '') {
              setLinkError(false)
            } else {
              setLinkError(true)
            }
          }}
          error={linkError}
          helperText={linkError ? "This doesn't seem to be a valid dti link." : ""}
          fullWidth
        />

        {/* Preference radio */}
        <FormControl>
          <FormLabel>Preference</FormLabel>
          <RadioGroup
            row
            value={preference}
            onChange={(e) => setPreference(e.target.value)}
          >
            <FormControlLabel value="classic" control={<Radio />} label="Classic" />
            <FormControlLabel value="2020" control={<Radio />} label="2020" />
          </RadioGroup>
        </FormControl>

        {/* Save button */}
        <Button
          variant="contained"
          color="primary"
          onClick={handleSave}
          sx={{ justifyContent: "center" }}
        >
          Convert
        </Button>
      </Box>
    )
  }

  return (
    <Box sx={{ p: 2.5 }}>
      <Section id="intro" title="Neoboard Fonts">
        <Typography
          variant="caption"
          color="secondary"
          sx={{ mt: -1, mb: 2, display: "block" }}
        >
          Last updated: September 2025
        </Typography>

        <Typography paragraph>
          If you want a handy neoboard font to display your tradelist, here's a few premade options! To change your neoboard post settings, go to <Link href="https://www.neopets.com/settings/neoboards/">Neoboard Preferences</Link> on-site. The first box is what you'd have to copy and paste into your neoHTML box and the second corresponds to the neosignature box. If you see a red asterisk (*), that indicates that the font requires a neoboard pen to work.
        </Typography>

        <Typography paragraph>
          You can find all these fonts and more on-site at <Link href="https://www.neopets.com/~suaki">Midnight Studio</Link>. We are highlighting the selection of NC trading fonts specifically as the Stylisher project focuses on providing NC resources!
        </Typography>

        <Box
          display="flex"
          flexDirection={{ xs: "column", md: "row" }}
          gap={2}
          pb={4}
        >
          {/* Left side */}
          <Box flex={1} p={2} borderRadius={2}>

            <Typography paragraph>
              All fonts have a link placeholder. For your convenience, feel free to paste your dti tradelist link into the form and we will change all the placeholders to your link so you may copy and paste to site with ease.
            </Typography>
            <Typography paragraph>
              <b>Note:</b> Feel free to input any dti link. If you're using classic and change your mind to 2020, no need to copy and paste again. We'll convert it for you!
            </Typography>
          </Box>

          {/* Right side */}
          <Box flex={1} p={2}>
            {userDetails()}
          </Box>
        </Box>

        {fontList.map((font) => {
          return (
            <FontPreview
              avatarURL={font.avatarURL}
              avatarLabel={font.avatarLabel}
              imageSrc={font.previewImg}
              label={font.name}
              requiresPen={font.penRequired}
              neohtml={font.neohtml}
              neosignature={font.neosignature}
            />
          )
        })}

      </Section>
    </Box>
  );
};

export default NeosignaturesPage;